import React, { useMemo } from 'react';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { CapacityResponse, OfficeWithCapacity } from "@features/desks/services/OfficeCapacityService";
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { Column, SpaceBetweenRow } from '@shared/ui/atoms/StructuralLayout';
import { useSelector } from "react-redux";
import { DesksAvailableLabel } from '@shared/ui/molecules/DesksAvailableLabel';
import { AUTO_EXPAND_LIMIT, DailyOfficeArea } from "./DailyOfficeArea";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { DeskReservations } from '@features/desks/services/DeskBookingService';
import { selectActiveDay, selectActivePeriod } from "../../../../store/editMovements.duck";
import { OfficeListUserRow } from "./OfficeListUserRow";
import { OfficesOfParentWithCapacities } from '@features/desks/hooks/OfficesOfParentWithCapacities';
import { DeskReservationsInOffice } from '@features/desks/hooks/DeskReservationsInOffice';
import { selectIsInTeams } from "@shared/store/auth.duck";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';
import { hasDesksOrAreas } from "./openOfficeUsers";

export function FloorUserListView(props: Props) {
  const {floor, capacity} = props;
  const selectedDate = useSelector(selectActiveDay);
  const activePeriod = useSelector(selectActivePeriod);
  const isInTeams = useSelector(selectIsInTeams);

  const areasWithCapacities = OfficesOfParentWithCapacities(floor, selectedDate);
  const deskReservations = DeskReservationsInOffice(floor, selectedDate);

  const floorHasDesksOrAreas = useMemo(() => hasDesksOrAreas(floor), [floor]);

  if (!floor) {
    return null;
  }

  return (
    <>
      {floorHasDesksOrAreas && <SpaceBetweenRow>
        <Column>
          <HeadlineSmall>{floor.label}</HeadlineSmall>
          {selectedDate && <DesksAvailableLabel office={floor}
                                                date={selectedDate}
                                                period={activePeriod} />}
        </Column>

        {!isInTeams && <div>
          <OutlineButton text={'button.view'} size={ButtonSize.Small}
                         click={() => window.location.href = `/whereabouts/company/all?office=${floor.id}&view=floor`} />
        </div>}
      </SpaceBetweenRow>}

      {floorHasDesksOrAreas ? <>
          {deskReservations.deskBookings.map((user: DeskReservations, key: number) => (
            <OfficeListUserRow key={key} containerOffice={floor}
                               firstName={user.firstName}
                               lastName={user.lastName}
                               amDeskLabel={user.amDeskLabel}
                               pmDeskLabel={user.pmDeskLabel}
                               fireWarden={user.fireWarden}
                               firstAider={user.firstAider}
                               mentalHealthAider={user.mentalHealthAider}
                               keyHolder={user.keyHolder}
            />
          ))}

          {areasWithCapacities.officesWithCapacities.map((area: OfficeWithCapacity, key: number) =>
            <DailyOfficeArea key={key} capacity={area.capacity}
                             initialOpenState={areasWithCapacities.officesWithCapacities.length < AUTO_EXPAND_LIMIT}
                             entity={area.office} />)}
        </> :
        <>
          <DailyOfficeArea capacity={capacity}
                           entity={floor}
                           initialOpenState={true}
          />
        </>}
    </>
  )
}

interface Props {
  floor: OfficeEntity;
  capacity?: CapacityResponse;
  loadUsers?: boolean;
  rootOffice: OfficeEntity
}
